export default "__VITE_PUBLIC_ASSET__d54684e2__"